import BusinessIcon from "@mui/icons-material/Business";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import MapIcon from "@mui/icons-material/Map";
import PublicIcon from "@mui/icons-material/Public";
import RoomIcon from "@mui/icons-material/Room";
import ShareIcon from "@mui/icons-material/Share";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CategoryIcon from "@mui/icons-material/Category";
import EventIcon from "@mui/icons-material/Event";
import FactoryIcon from "@mui/icons-material/Factory";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PeopleIcon from "@mui/icons-material/People";
import { Chip } from "@mui/material";

function renderExternalLink(value) {
  if (!value) return null;

  return (
    <a
      href={value.startsWith("http") ? value : `https://${value}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#00336C",
        fontWeight: 600,
        textDecoration: "none",
      }}
    >
      {value}
    </a>
  );
}

function cleanRows(rows) {
  return rows.filter((row) => row.showIf !== false);
}

export function incubatorProfileConfig(incubator = {}) {
  return [
    {
      title: "Incubator Information",
      rows: cleanRows([
        {
          icon: <BusinessIcon />,
          label: "Company Name",
          value: incubator.company_name,
        },
        {
          icon: <LanguageIcon />,
          label: "Website",
          value: renderExternalLink(incubator.website),
          showIf: Boolean(incubator.website),
        },
        {
          icon: <AutorenewIcon />,
          label: "Pipeline Status",
          value: (
            <Chip
              label={incubator.pipeline_status || "N/A"}
              size="small"
              sx={{
                fontWeight: 600,
                backgroundColor: "#eef3ff",
                color: "#00336C",
              }}
            />
          ),
        },
      ]),
    },
    {
      title: "Social Media",
      rows: cleanRows([
        {
          icon: <ShareIcon />,
          label: "Facebook",
          value: renderExternalLink(incubator.facebook),
          showIf: Boolean(incubator.facebook),
        },
        {
          icon: <ShareIcon />,
          label: "LinkedIn",
          value: renderExternalLink(incubator.linkedin),
          showIf: Boolean(incubator.linkedin),
        },
        {
          icon: <ShareIcon />,
          label: "Twitter",
          value: renderExternalLink(incubator.twitter),
          showIf: Boolean(incubator.twitter),
        },
      ]),
    },
    {
      title: "Business Details",
      rows: cleanRows([
        {
          icon: <FactoryIcon />,
          label: "Sector",
          value: incubator.sector,
          showIf: Boolean(incubator.sector),
        },
        {
          icon: <CategoryIcon />,
          label: "NAICS Text",
          value: incubator.naics_text,
          showIf: Boolean(incubator.naics_text),
        },
        {
          icon: <CategoryIcon />,
          label: "NAICS Code",
          value: incubator.naics_code,
          showIf: Boolean(incubator.naics_code),
        },
        {
          icon: <CategoryIcon />,
          label: "Custom Industry",
          value: incubator.industry_custom || incubator.industry,
          showIf: Boolean(incubator.industry_custom || incubator.industry),
        },
        {
          icon: <PeopleIcon />,
          label: "Employees",
          value: incubator.number_of_employees,
          showIf: Boolean(incubator.number_of_employees),
        },
        {
          icon: <CategoryIcon />,
          label: "Industries Served",
          value: incubator.industries_served,
          showIf: Boolean(incubator.industries_served),
        },
        {
          icon: <PublicIcon />,
          label: "Geographic Markets Covered",
          value: incubator.geographic_markets_covered,
          showIf: Boolean(incubator.geographic_markets_covered),
        },
        {
          icon: <MonetizationOnIcon />,
          label: "Annual Revenue",
          value: incubator.annual_revenue,
          showIf: Boolean(incubator.annual_revenue),
        },
        {
          icon: <EventIcon />,
          label: "Lease Expiration",
          value: incubator.lease_expiration,
          showIf: Boolean(incubator.lease_expiration),
        },
      ]),
    },
    {
      title: "Location",
      rows: cleanRows([
        {
          icon: <RoomIcon />,
          label: "Address",
          value: incubator.address,
          showIf: Boolean(incubator.address),
        },
        {
          icon: <LocationCityIcon />,
          label: "City",
          value: incubator.city,
          showIf: Boolean(incubator.city),
        },
        {
          icon: <MapIcon />,
          label: "State",
          value: incubator.state,
          showIf: Boolean(incubator.state),
        },
        {
          icon: <MapIcon />,
          label: "Zip Code",
          value: incubator.zip_code,
          showIf: Boolean(incubator.zip_code),
        },
        {
          icon: <PublicIcon />,
          label: "Country",
          value: incubator.country,
          showIf: Boolean(incubator.country),
        },
        {
          icon: <BusinessIcon />,
          label: "Room Number",
          value: incubator.room_number,
          showIf: Boolean(incubator.room_number),
        },
        {
          icon: <RoomIcon />,
          label: "Mailing Address",
          value: incubator.mailing_address,
          showIf: Boolean(incubator.mailing_address),
        },
      ]),
    },
    {
      title: "Contact",
      rows: cleanRows([
        {
          icon: <AlternateEmailIcon />,
          label: "Contact Name",
          value: incubator.contact_name,
          showIf: Boolean(incubator.contact_name),
        },
        {
          icon: <ContactPhoneIcon />,
          label: "Phone",
          value: incubator.contact_telephone,
          showIf: Boolean(incubator.contact_telephone),
        },
        {
          icon: <EmailIcon />,
          label: "Email",
          value: incubator.contact_email,
          showIf: Boolean(incubator.contact_email),
        },
      ]),
    },
  ].filter((section) => section.rows.length > 0);
}
